module.exports = __webpack_public_path__ + "static/media/pick.db7d5980.png";